import React, { useState } from "react";
import { showError, showSuccess } from "../../utils/toastUtils";
import { useLoader } from "../../utils/LoaderUtils";
import BannerAPI from "../../api/BannerApi";
import ImageUploader from "../../components/partials/ImageUploader";
import { handleApiValidationError } from "../../utils/apiErrorHandler";
import SubmitButton from "../../components/partials/global/SubmitButton";

function AddNew() {
  const { showLoader, hideLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const INITIAL_FORM_DATA = {
    title: "",
    subtitle: "",
    redirectUrl: "",
    position: "top",
    image: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleImageUploadSuccess = (type, url) => {
    setFormData((prev) => ({
      ...prev,
      [type]: url,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.image) {
      newErrors.image = "Banner is required";
    }

    if (!formData.position) {
      newErrors.position = "Position Field is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setIsLoading(true);
    showLoader();

    try {
      const res = await BannerAPI.addDetails(formData);

      if (res.code === 200) {
        showSuccess(res.message);
        setFormData(INITIAL_FORM_DATA);
      } else {
        showError(res.message);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Add a New Banner</h4>
            <h6>
              Create a new promotional banner to engage customers and drive
              store visibility.
            </h6>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h4>Add Details</h4>
          </div>
          <div className="card-body profile-body">
            <form method="post" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <label className="form-label">
                    Banner <span className="text-danger">*</span>
                  </label>
                  <ImageUploader
                    type="image"
                    label="Banner"
                    value={formData.image}
                    onUploadSuccess={handleImageUploadSuccess}
                    assetType="banners"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-pencil"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Title"
                        name="title"
                        value={FormData.title}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.title && (
                      <span className="errors text-danger">{errors.title}</span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">SubTitle</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-pencil"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="SubTitle"
                        name="subtitle"
                        value={formData.subTitle}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.subTitle && (
                      <span className="errors text-danger">
                        {errors.subTitle}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Redirect Url</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-globe"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Redirect Url"
                        name="redirectUrl"
                        value={formData.redirectUrl}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.redirectUrl && (
                      <span className="errors text-danger">
                        {errors.redirectUrl}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Position</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa fa-location"></i>
                      </span>
                      <select
                        value={formData.position}
                        name="position"
                        className="form-select"
                        onChange={handleChange}
                      >
                        <option value="top">Top</option>
                        <option value="middle">Middle</option>
                      </select>
                    </div>
                    {errors.position && (
                      <span className="errors text-danger">
                        {errors.position}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-end">
                  <SubmitButton
                    isLoading={isLoading}
                    text="Submit Details"
                    loadingText="Submitting..."
                  ></SubmitButton>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddNew;
